import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface Style {
  medium?: boolean
  error?: boolean
  disableDelete?: boolean
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 32px;
  .margin-top {
    margin-top: 32px;
  }
`

export const Cell = styled.div`
  padding: 30px 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  /* margin: 0 15px; */
  overflow: hidden;
`

export const Text = styled.p`
  font-size: 14px;
  max-width: 150px;
  font-weight: ${(props: Style) => {
    if (props.medium) return '400'
    return '400'
  }};
  text-align: ${(props: Style) => {
    if (props.medium) return 'center'
    return 'left'
  }};
  color: ${(props: Style) => {
    if (props.error) return Theme.pallete.SENARY
    return Theme.pallete.PRIMARY
  }};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Status = styled.p`
  padding: 6px 8px;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  border-radius: 4px;
  background-color: ${(props: Style) => {
    if (props.error) return `${Theme.pallete.SENARY}16`
    return `${Theme.pallete.QUINARY}10`
  }};
  color: ${(props: Style) => {
    if (props.error) return Theme.pallete.SENARY
    return Theme.pallete.QUINARY
  }};
`

export const SmallRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .pic-wrapper {
    margin-right: 8px;
    border-radius: 5px;
    background-color: #eeeeee;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .specialist-pic {
    width: 27px;
    border-radius: 5px;
    margin: 3px;
  }
`
export const Trash = styled.img`
  cursor: pointer;
  width: 16px;
  opacity: ${(props: Style) => {
    if (props.disableDelete) return 0.2
    return 1
  }};
`
